/* Every Accordion Card, on every page, one script. Opening and closing is Bootstrap's own collapse; this adds, from the card's own markup and no wording:
   the plus turning to a minus, one line open at a time in the Rows layout, and, for a line that names a list (data-source), drawing that list in its panel
   the first time the line is opened (the same App Records widget the list pages use, so its buttons work in the panel). */
(function () {
	const $ = window.jQuery;
	if (!$) return;
	const icon = (panel) => $(panel).prev(".rfhq-accordion-trigger").find(".rfhq-accordion-icon");

	$(document).on("show.bs.collapse", ".rfhq-accordion-panel", function () {
		icon(this).addClass("rfhq-accordion-icon--open");
		const rows = $(this).closest(".rfhq-accordion-card--rows");
		if (rows.length) {  // the lines of a list may each be a card of their own: the others anywhere in the same list close
			rows.closest(".rfhq-records-wrapper, .rfhq-accordion-items").find(".rfhq-accordion-card--rows .rfhq-accordion-panel.show").not(this).collapse("hide");
		}
		const live = $(this).find(".rfhq-accordion-live")[0];
		if (live && !live.dataset.drawn) {
			live.dataset.drawn = "1";
			const list = document.createElement("div");
			list.className = "rfhq-app-records";
			list.dataset.source = live.dataset.source;
			list.dataset.args = "{}";
			list.innerHTML = '<div class="rfhq-records-wrapper"></div>';
			live.append(list);
			if (typeof window.rfhqMountRecords === "function") window.rfhqMountRecords();
		}
	});
	// A button in a panel changed something: the list the lines belong to is asked again, so what each line says is current, and the line that was open is opened again.
	document.addEventListener("rfhq:records-changed", function (event) {
		const live = event.target.closest && event.target.closest(".rfhq-accordion-live");
		const parent = live && live.parentElement && live.parentElement.closest(".rfhq-app-records");
		if (!parent) return;
		const cells = Array.from(parent.querySelectorAll(":scope > .rfhq-records-wrapper > .rfhq-record-cell"));
		const open = cells.findIndex((cell) => cell.contains(live));
		const again = function () {
			parent.removeEventListener("rfhq:records-drawn", again);
			const cell = parent.querySelectorAll(":scope > .rfhq-records-wrapper > .rfhq-record-cell")[open];
			const panel = cell && cell.querySelector(".rfhq-accordion-panel");
			if (panel) $(panel).collapse("show");
		};
		parent.addEventListener("rfhq:records-drawn", again);
		parent.dispatchEvent(new CustomEvent("rfhq:reload"));
	});
	$(document).on("hide.bs.collapse", ".rfhq-accordion-panel", function () { icon(this).removeClass("rfhq-accordion-icon--open"); });
})();
